import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@env';

@Injectable({
  providedIn: 'root',
})
export class ApplicationFilesService {
  private readonly baseUrl = environment.ApiBaseUrl;

  constructor(private readonly http: HttpClient) {}

  getFilesForDownload(folderName: string): Observable<string[]> {
    return this.http.get<string[]>(`${this.baseUrl}/ApplicationFiles`, {
      params: { folderName },
    });
  }

  downloadFile(filePath: string): void {
    const filename = filePath.split(/[/\\]/).pop() || 'download';

    this.http
      .get(`${this.baseUrl}/ApplicationFiles/download`, {
        params: { filePath },
        responseType: 'blob',
      })
      .subscribe((blob) => {
        if (!blob) return;

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      });
  }
}
